import { render, staticRenderFns } from "./Cardapio.vue?vue&type=template&id=0d8e4a8a"
import script from "./Cardapio.vue?vue&type=script&lang=js"
export * from "./Cardapio.vue?vue&type=script&lang=js"
import style0 from "./Cardapio.vue?vue&type=style&index=0&id=0d8e4a8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports